import React, { useState } from 'react';
import {
  ChevronLeftIcon,
  ChevronRightIcon,
  CloseIcon,
} from '../../../content/svg-component';
import './sideBarPanel.scss';

const SideBarPanel = ({ direction, children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <div
        className={`w-100 d-flex flex-column d-md-none position-fixed ${
          isMenuOpen
            ? `sideBar-open-${direction}`
            : `sideBar-close-${direction}`
        }  `}
      >
        <div
          className={`w-100 font-large d-flex flex-column d-md-none align-items-center position-fixed  h-100 bg-primary p-3 text-white`}
        >
          <div
            className="w-100 d-flex justify-content-end"
            onClick={toggleMenu}
          >
            <CloseIcon size={24} color="white" />
          </div>
          <div className={`w-100 p-4 pb-3 scroll-sidebar`}>{children}</div>
        </div>
      </div>
      {!isMenuOpen && (
        <div className="w-100 d-flex d-md-none position-fixed">
          <div
            style={{
              position: 'fixed',
              bottom: '15px',
              left: direction === 'rtl' && '15px',
              right: direction === 'ltr' && '15px',
            }}
            onClick={toggleMenu}
          >
            {direction === 'ltr' ? (
              <div className="p-2 m-1 bg-white shadow p-3 rounded-circle toggle-border">
                <ChevronLeftIcon size={24} color={'#3d4a8f'} />
              </div>
            ) : (
              <div className="p-2 m-1 bg-white shadow p-3 rounded-circle toggle-border">
                <ChevronRightIcon size={24} color={'#3d4a8f'} />
              </div>
            )}
          </div>
        </div>
      )}
      <div className="col-3 h-100 px-xl-4 px-3 pt-4 bg-primary text-white d-md-flex d-none">
        <div className="w-100 d-flex flex-column px-xl-1 px-2">{children}</div>
      </div>
    </>
  );
};

export default SideBarPanel;
